module.exports = "/images/marking-icon-draw_new.svg?e657fe9c9b03baee84e2ac33b5c1ff49";